<h2 mat-dialog-title>QR Codes - {{data.product_title}}</h2>

<mat-dialog-content class="dialog-table-content" style="padding-top: 10px !important;">
    <div class="table-responsive"
        style="max-height: 60vh; overflow: auto; border: 1px solid #edf2f7; border-radius: 8px;">
        <table mat-table [dataSource]="dataSource">

            <!-- Sr No -->
            <ng-container matColumnDef="srNo">
                <th mat-header-cell *matHeaderCellDef>Sr.No</th>
                <td mat-cell *matCellDef="let element">{{ element.srNo }}</td>
            </ng-container>

            <!-- Serial Number -->
            <ng-container matColumnDef="serial_number">
                <th mat-header-cell *matHeaderCellDef>Serial Number</th>
                <td mat-cell *matCellDef="let element">
                    {{ element.serial_number }}
                </td>
            </ng-container>

            <!-- Batch Name -->
            <ng-container matColumnDef="batch_name">
                <th mat-header-cell *matHeaderCellDef>Batch</th>
                <td mat-cell *matCellDef="let element">
                    {{ element.batch_name || '-' }}
                </td>
            </ng-container>

            <!-- User Name -->
            <ng-container matColumnDef="user_name">
                <th mat-header-cell *matHeaderCellDef>User Name</th>
                <td mat-cell *matCellDef="let element">
                    {{ element.user_name || '-' }}
                </td>
            </ng-container>

            <!-- Mobile -->
            <ng-container matColumnDef="user_mobile">
                <th mat-header-cell *matHeaderCellDef>Mobile</th>
                <td mat-cell *matCellDef="let element">
                    {{ element.user_mobile || '-' }}
                </td>
            </ng-container>

            <!-- Points Awarded -->
            <ng-container matColumnDef="points_awarded">
                <th mat-header-cell *matHeaderCellDef>Points</th>
                <td mat-cell *matCellDef="let element">
                    {{ element.points_awarded || 0 }}
                </td>
            </ng-container>

            <!-- Scan Count -->
            <ng-container matColumnDef="scan_count">
                <th mat-header-cell *matHeaderCellDef>Scans</th>
                <td mat-cell *matCellDef="let element">
                    {{ element.current_scan_count || 0 }}/{{ element.max_scans || 0 }}
                </td>
            </ng-container>

            <!-- Last Scanned -->
            <ng-container matColumnDef="last_scanned_at">
                <th mat-header-cell *matHeaderCellDef>Last Scanned</th>
                <td mat-cell *matCellDef="let element">
                    {{ element.last_scanned_at ? (element.last_scanned_at | date:'dd-MMM-yyyy HH:mm') : '-' }}
                </td>
            </ng-container>

            <!-- Device -->
            <ng-container matColumnDef="device_name">
                <th mat-header-cell *matHeaderCellDef>Device</th>
                <td mat-cell *matCellDef="let element">
                    {{ element.device_name || '-' }}
                </td>
            </ng-container>

            <!-- Status -->
            <ng-container matColumnDef="status">
                <th mat-header-cell *matHeaderCellDef>Status</th>
                <td mat-cell *matCellDef="let element">

                    <span class="status-pill" [class.active]="element.current_scan_count < element.max_scans"
                        [class.claimed]="element.current_scan_count >= element.max_scans">

                        {{ element.current_scan_count >= element.max_scans ? 'Used' : 'Active' }}

                    </span>

                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

        </table>
    </div>
    <mat-paginator [pageSizeOptions]="[10, 25, 50]" showFirstLastButtons></mat-paginator>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button mat-button mat-dialog-close>Close</button>
</mat-dialog-actions>